import { useRemoteParticipants } from "@livekit/components-react";
import { useGameStore } from "../../store/gameStore";
import { Button } from "../ui/button";
import { MicOff } from "lucide-react";

// GM-only bar to open/close a private voice line with one connected player, without interrupting
// the rest of the table's call (see WhisperControls.jsx for the actual audio-subscription effect).
export default function WhisperBar({ myUserId, myMemberId, members, sendWs }) {
  const participants = useRemoteParticipants();
  const whisper = useGameStore((s) => s.voiceWhisper);
  const setVoiceWhisper = useGameStore((s) => s.setVoiceWhisper);
  const idToMember = Object.fromEntries((members || []).map((m) => [m.user_id, m]));
  const connectedPlayers = participants.map((p) => idToMember[p.identity]).filter((m) => m && m.role !== "gm");

  const startWhisper = (targetMember) => {
    const data = { active: true, gm_member_id: myMemberId, gm_user_id: myUserId, target_member_id: targetMember.id, target_user_id: targetMember.user_id };
    setVoiceWhisper(data);
    sendWs({ type: "voice_whisper", data });
  };

  const endWhisper = () => {
    const data = { active: false, gm_member_id: null, gm_user_id: null, target_member_id: null, target_user_id: null };
    setVoiceWhisper(data);
    sendWs({ type: "voice_whisper", data });
  };

  if (connectedPlayers.length === 0) return null;

  return (
    <div className="flex items-center gap-1.5 flex-wrap px-3 py-2 border-t border-white/10 bg-black/40" data-testid="whisper-bar">
      {whisper?.active ? (
        <>
          <span className="text-xs text-[#D4AF37]">Whispering to {idToMember[whisper.target_user_id]?.display_name || "player"}</span>
          <Button data-testid="end-whisper-button" size="sm" variant="secondary" className="rounded-full h-7 gap-1 text-[10px]" onClick={endWhisper}>
            <MicOff className="w-3 h-3" /> End Whisper
          </Button>
        </>
      ) : (
        connectedPlayers.map((m) => (
          <Button
            key={m.id}
            data-testid={`whisper-button-${m.id}`}
            size="sm"
            variant="secondary"
            className="rounded-full h-7 text-[10px]"
            onClick={() => startWhisper(m)}
          >
            Whisper to {m.display_name}
          </Button>
        ))
      )}
    </div>
  );
}
